// apps/cop/src/components/BrandMark.tsx
// CONTRACT:C4-DESIGN-TOKENS.1.0
//
// The TAK·TDF brand mark — the SEALED-OBJECT HEXAGON. The hexagon is already the
// product's map glyph for a sealed/protected object, so the mark is that same idea
// made emblematic: a hexagonal seal, a vertical KEYLINE entering from the top vertex
// (the secure spine reaching the object), and a small solid inner hexagon — the
// sealed payload — where the keyline lands. A deep-teal lower facet gives the seal
// dimension without gradient or glow (flat, geometric, HUD-grade).
//
// The teal ramp is used SEMANTICALLY, one value per role (never decoration):
//   teal-deep  (interactive-default, #0E6E73) → the facet (rest / depth)
//   teal-spine (ui-accent,           #1FB6B6) → the seal + payload (the identity)
//   teal-light (interactive-active,  #5FE3DE) → the keyline (entry / active)
// Colors resolve from the live theme via CSS variables with DDIL-safe fallbacks
// (the C4 semantic-token-only discipline). The static favicon (public/favicon.svg)
// is a heavier-stroke cut of this same geometry.

export function BrandMark({
  size = 44,
  className,
}: {
  /** Rendered square size in px (~44 splash, ~28 login). */
  size?: number;
  className?: string;
}): JSX.Element {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      role="img"
      aria-label="TAK TDF"
    >
      {/* Lower facet — the seal's inner dimension (deep teal, quiet). */}
      <path
        d="M46.7 40.5 L32 49 L17.3 40.5"
        stroke="var(--color-interactive-default, #0E6E73)"
        strokeWidth="1.5"
      />
      {/* Keyline — the spine entering the seal from the top vertex. */}
      <path
        d="M32 8 L32 26"
        stroke="var(--color-interactive-active, #5FE3DE)"
        strokeWidth="1.5"
      />
      {/* The sealed payload — a solid inner hexagon where the keyline lands. */}
      <path
        d="M32 26 L37.2 29 L37.2 35 L32 38 L26.8 35 L26.8 29 Z"
        fill="var(--ui-accent, #1FB6B6)"
      />
      {/* The hexagonal seal itself. */}
      <path
        d="M32 6 L54.5 19 L54.5 45 L32 58 L9.5 45 L9.5 19 Z"
        stroke="var(--ui-accent, #1FB6B6)"
        strokeWidth="2.5"
      />
    </svg>
  );
}
